/**
 * Shared constants for the admin dashboard tabs.
 *
 * Kept in one place so adding a new CTA only requires updating one file —
 * CTAAnalyticsTab and ABTestingPanel both depend on these maps.
 */

export const CTA_COLORS = {
  explore_peptides: '#E63946',
  calculators_tools: '#8b5cf6',
  hyrox_hub: '#FFD100',
  search_bar: '#6b7280',
  trending_card: '#f97316',
  series_card: '#06b6d4',
  affiliate_banner: '#c8ff00',
  popup_shop_apr: '#22c55e',
  popup_copy_code: '#a3e635',
  series_browse_card: '#3b82f6',
  series_start_reading: '#ec4899',
  apr_tesa_retatrutide_inline: '#f43f5e',
  apr_tesa_tesamorelin_inline: '#10b981',
  apr_tesa_final_tesa: '#14b8a6',
  apr_tesa_final_reta: '#fb923c',
};

export const CTA_LABELS = {
  explore_peptides: 'Explore All Peptides',
  calculators_tools: 'Calculators & Tools',
  hyrox_hub: 'HYROX Hub',
  search_bar: 'Search Bar',
  trending_card: 'Trending Now Card',
  series_card: '8 Learning Paths',
  affiliate_banner: '25% OFF Banner',
  popup_shop_apr: 'Popup: Shop APR',
  popup_copy_code: 'Popup: Copy Code',
  series_browse_card: 'Series Browse Card',
  series_start_reading: 'Series: Start Reading',
  apr_tesa_retatrutide_inline: 'Tesa Article · Retatrutide Inline',
  apr_tesa_tesamorelin_inline: 'Tesa Article · Tesamorelin Inline',
  apr_tesa_final_tesa: 'Tesa Article · Final CTA (Tesamorelin)',
  apr_tesa_final_reta: 'Tesa Article · Final CTA (Retatrutide)',
};

export const VARIANT_COLORS = ['#E63946', '#3b82f6', '#22c55e', '#f59e0b', '#8b5cf6'];
